import { render, staticRenderFns } from "./GeneralEdit.vue?vue&type=template&id=05eb9340&scoped=true"
import script from "./GeneralEdit.vue?vue&type=script&lang=js"
export * from "./GeneralEdit.vue?vue&type=script&lang=js"
import style0 from "./GeneralEdit.vue?vue&type=style&index=0&id=05eb9340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb9340",
  null
  
)

export default component.exports